<template>
<v-menu offset-y top :close-on-content-click="false" v-model="menu">
            <template v-slot:activator="{ on, attrs }">
              <v-btn id="pfid1657730445" :loading="sending" text v-on="on" v-bind="attrs"><v-icon left>$send</v-icon>{{$t('campaigns.summary.preview.send')}}</v-btn>
            </template>
            <v-card style="width:400px">
              <v-card-title>{{$t('common.emailAddress')}}</v-card-title>
              <v-card-text>
                <v-text-field class="pfcl1665738982" 
                  v-model="recipient"
                  type="email"
                  append-outer-icon="$send"
                  @click:append-outer="send"
                />
              </v-card-text>
            </v-card>
        </v-menu>
</template>
<script>

export default {
    name: 'CampaignPreviewSender',
    data() {
        return {
            recipient: this.$store.getters['auth/email'],
            sending: false,
            menu: false
        }
    },
    props: { campaign: String, variant: String },
    methods: {
        async send() {
            this.sending = true;
            this.menu = false;
            let success = await this.$store.dispatch('campaigns/sendTestEmail', {email: this.recipient, campaignID: this.campaign, variantID: this.variant });
            this.sending = false;
            this.$store.dispatch('ui/notify', { error: !success, text: success ? this.$t('campaigns.notify.previewSent') : this.$t('campaigns.notify.previewError')});
        }
    }
}
</script>

<style>

</style>